module.exports = __webpack_public_path__ + "img/notification.002261ea.png";